import { Grid } from "@mui/material";
import { FormikProps } from "formik";
import Flex from "../../../../../../../../../components/Flex";
import StyledButtonV2 from "../../../../../../../../../components/app/StyledButtonV2";
import StyledFormModal from "../../../../../../../../../components/globalModal/StyledModal";
import useDisclosure from "../../../../../../../../../hooks/use-disclosure";
import { Form2Payload } from "../../../../../../scheduling/appointment/encounter/encounter-constant";
import { StyleAddButton } from "../../../../../../scheduling/appointment/encounter/default-forms/form-1/StyledAddButton";
import CbtCheckboxNoteList from "./CbtCheckboxNoteList";
import CbtCheckboxNoteListView from "./CbtCheckboxNoteListView";

// key = boolean flag, `${key}Note` = its free-text note (nested under
// psychotherapyCbtVisitNote).
export const CBT_COGNITIVE_DISTORTIONS = [
  { key: "allOrNothingThinking", label: "All-or-nothing thinking" },
  { key: "catastrophizing", label: "Catastrophizing" },
  { key: "overgeneralization", label: "Overgeneralization" },
  { key: "mentalFiltering", label: "Mental filtering" },
  { key: "personalization", label: "Personalization" },
  { key: "mindReading", label: "Mind reading" },
  { key: "fortuneTelling", label: "Fortune telling" },
  { key: "emotionalReasoning", label: "Emotional reasoning" },
  { key: "labeling", label: "Labeling" },
  { key: "shouldStatements", label: "Should statements" },
] as const;

interface CbtCognitiveDistortionsProps {
  formik: FormikProps<Form2Payload>;
}

const CbtCognitiveDistortions = ({ formik }: CbtCognitiveDistortionsProps) => {
  const disclosure = useDisclosure();

  return (
    <Grid size={12}>
      <StyleAddButton
        w="100%"
        centerLabel
        onClick={() => disclosure.open()}
        label="Cognitive Distortions Identified"
      />

      <CbtCheckboxNoteListView
        formik={formik}
        items={CBT_COGNITIVE_DISTORTIONS}
      />

      <StyledFormModal
        open={disclosure.opened}
        onClose={() => disclosure.close()}
        dialogTitle="Cognitive Distortions Identified"
        dialogAction={
          <StyledButtonV2
            label="Close"
            variant="contained"
            onClick={() => disclosure.close()}
            sx={{ width: "105px" }}
          />
        }
        sx={{
          "& .MuiDialog-paper": {
            width: "60vw",
            height: "80vh",
          },
        }}
      >
        <Flex flexDirection="column" gap={1} width="100%" pt={2}>
          <CbtCheckboxNoteList
            formik={formik}
            items={CBT_COGNITIVE_DISTORTIONS}
          />
        </Flex>
      </StyledFormModal>
    </Grid>
  );
};

export default CbtCognitiveDistortions;
